import React from 'react';
import * as styles from './Shell.module.scss';

import { Footer } from 'patterns/Footer';
import { Header } from 'patterns/Header';
import { SEO } from 'patterns/SEO';

function Shell({
    children,
    pageDescription,
    pageSocialImage,
    pageTitle,
    pathname,
}) {
    const data = {
        header: {
            navLinks: [
                {
                    nav_cta: false,
                    nav_link_text: {
                        text: 'Services',
                    },
                    nav_link_url: {
                        link_type: 'Document',
                        type: 'services_index_page',
                        uid: 'services',
                        url: '/services',
                    },
                },
                {
                    nav_cta: false,
                    nav_link_text: {
                        text: 'About',
                    },
                    nav_link_url: {
                        link_type: 'Document',
                        type: 'content_page',
                        uid: 'about',
                        url: '/about',
                    },
                },
                {
                    nav_cta: true,
                    nav_link_text: {
                        text: 'Hire me',
                    },
                    nav_link_url: {
                        link_type: 'Document',
                        type: 'contact_page',
                        uid: 'contact',
                        url: '/contact',
                    },
                },
            ],
        },
        footer: {
            ctaTitle: 'Have a project in mind?',
            ctaText: 'Let’s create something great together',
            ctaUrl: {
                link_type: 'Document',
                type: 'contact_page',
                uid: 'contact',
                url: '/contact',
            },
            navLinks: [
                {
                    nav_type: 'Primary',
                    nav_link_text: {
                        text: 'Testimonials',
                    },
                    nav_link_url: {
                        link_type: 'Document',
                        type: 'content_page',
                        uid: 'testimonials',
                        url: '/testimonials',
                    },
                },
                {
                    nav_type: 'Primary',
                    nav_link_text: {
                        text: 'Articles',
                    },
                    nav_link_url: {
                        link_type: 'Document',
                        type: 'blog_page',
                        uid: 'articles',
                        url: '/articles',
                    },
                },
                {
                    nav_type: 'Secondary',
                    nav_link_text: {
                        text: 'Privacy',
                    },
                    nav_link_url: {
                        link_type: 'Document',
                        type: 'content_page',
                        uid: 'privacy',
                        url: '/privacy',
                    },
                },
            ],
            socialLinks: [
                {
                    social_link_type: {
                        text: 'LinkedIn',
                    },
                    social_link_url: {
                        link_type: 'Web',
                        url: 'https://www.linkedin.com/in/robsimps',
                    },
                },
                {
                    social_link_type: {
                        text: 'Dribbble',
                    },
                    social_link_url: {
                        link_type: 'Web',
                        url: 'https://robsimpson.dribbble.com',
                    },
                },
            ],
        },
    };

    return (
        <div className={styles['shell']}>
            <SEO
                pageDescription={pageDescription}
                pageSocialImage={pageSocialImage}
                pageTitle={pageTitle}
                pathname={pathname}
            />
            <Header navLinks={data.header.navLinks} />
            <main className={styles['shell']} id="main-content">
                {children}
            </main>
            <Footer
                ctaTitle={data.footer.ctaTitle}
                ctaText={data.footer.ctaText}
                ctaUrl={data.footer.ctaUrl}
                navLinks={data.footer.navLinks}
                socialLinks={data.footer.socialLinks}
            />
        </div>
    );
}

export { Shell };
